import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "emp-form-wrapper" }
const _hoisted_2 = { class: "emp-acc__title" }
const _hoisted_3 = { class: "emp-acc__title-text" }
const _hoisted_4 = { class: "emp-acc__panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridIntretinuti = _resolveComponent("GridIntretinuti")!
  const _component_GridCertificateMedicale = _resolveComponent("GridCertificateMedicale")!
  const _component_GridStudii = _resolveComponent("GridStudii")!
  const _component_GridContracteMunca = _resolveComponent("GridContracteMunca")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxAccordion = _resolveComponent("DxAccordion")!

  return (_openBlock(), _createElementBlock("div", {
    class: "emp-card",
    key: `emp-${_ctx.employeeId}`
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_DxAccordion, {
        class: "emp-acc",
        "data-source": _ctx.sections,
        multiple: false,
        "animation-enabled": true,
        "defer-rendering": false,
        "focus-state-enabled": false
      }, {
        title: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(data.title), 1),
            _cache[0] || (_cache[0] = _createElementVNode("span", {
              class: "emp-acc__chev",
              "aria-hidden": "true"
            }, null, -1))
          ])
        ]),
        item: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_4, [
            (data.key === 'intretinuti')
              ? (_openBlock(), _createBlock(_component_GridIntretinuti, {
                  "employee-id": _ctx.employeeId,
                  "employee-row": _ctx.employeeRow,
                  key: _ctx.employeeId
                }, null, 8, ["employee-id", "employee-row"]))
              : _createCommentVNode("", true),
            (data.key === 'certificateMedicale')
              ? (_openBlock(), _createBlock(_component_GridCertificateMedicale, {
                  "employee-id": _ctx.employeeId,
                  "employee-row": _ctx.employeeRow,
                  key: _ctx.employeeId
                }, null, 8, ["employee-id", "employee-row"]))
              : _createCommentVNode("", true),
            (data.key === 'studii')
              ? (_openBlock(), _createBlock(_component_GridStudii, {
                  "employee-id": _ctx.employeeId,
                  "employee-row": _ctx.employeeRow,
                  key: _ctx.employeeId
                }, null, 8, ["employee-id", "employee-row"]))
              : _createCommentVNode("", true),
            (data.key === 'contracte')
              ? (_openBlock(), _createBlock(_component_GridContracteMunca, {
                  "employee-id": _ctx.employeeId,
                  "employee-row": _ctx.employeeRow,
                  key: _ctx.employeeId
                }, null, 8, ["employee-id", "employee-row"]))
              : (_openBlock(), _createBlock(_component_DxForm, {
                  key: 4,
                  "label-location": 'top',
                  "col-count": 2,
                  "col-count-by-screen": { xs: 1, sm: 2, md: 2 },
                  "min-col-width": 220,
                  "styling-mode": 'filled',
                  class: "emp-form"
                }, {
                  default: _withCtx(() => [
                    (data.key === 'contracte')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                      : (data.key === 'fisiere')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
                        : (data.key === 'studii')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [], 64))
                          : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
          ])
        ]),
        _: 1
      }, 8, ["data-source"])
    ])
  ]))
}